import React from 'react'
import { useTranslation } from 'react-i18next'
import CTA from '../../../common/CTAButton/CTAButton'
import { useStateContext } from '../context/StateContext'
import { componentEvent } from '../../../utils/tracking'
import arrowLeft from '../assets/svgs/arrow-left.svg'
import arrowRight from '../assets/svgs/arrow-right.svg'
import children from '../assets/svgs/children.svg'

export default function ChildGender() {
  const [state, setState] = useStateContext()
  const { t } = useTranslation()

  function handleBoy() {
    componentEvent('bmi-calculator', 'content', 'click', 'Boy')

    setState(() => ({
      ...state,
      step: 'child-dob',
      gender: 'm',
    }))
  }

  function handleGirl() {
    componentEvent('bmi-calculator', 'content', 'click', 'Girl')

    setState(() => ({
      ...state,
      step: 'child-dob',
      gender: 'f',
    }))
  }

  function handleBack() {
    componentEvent('bmi-calculator', 'content', 'click', 'Back')

    setState(() => ({
      ...state,
      step: 'start',
      gender: null,
    }))
  }

  return (
    <div className="layout child-gender">
      <div className="layout__left">
        <div className="container">
          <div className="action">
            <h4>{t('bmi')}</h4>
            <p>{t('child-bmi-changes')}</p>
            <div className="cta-wrapper">
              <CTA className="cta cta__gender" onClick={() => handleBoy()}>
                {t('boy-upper')}
                <img src={arrowRight} alt="" />
              </CTA>
              <CTA className="cta cta__gender" onClick={() => handleGirl()}>
                {t('girl-upper')}
                <img src={arrowRight} alt="" />
              </CTA>
            </div>
          </div>
        </div>
      </div>
      <div className="layout__right">
        <div className="container">
          <img className="figure" src={children} alt="" />
          <div className="action">
            <h3>
              {t('calculate-a')}
              <span>{t('child')}</span>
            </h3>
            <CTA className="cta cta__arrow" onClick={() => handleBack()}>
              <img src={arrowLeft} alt="" />
            </CTA>
          </div>
        </div>
      </div>
    </div>
  )
}
